import * as React from "react";

import * as _ from "lodash";
import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

const ListItemTextLine = styled.span`
    display: inline-flex;
    max-width: 420px;
    > span {
        height: 18px;
    }
`;

export interface IListItem {
    text: string;
}

export interface ItemContainerProps extends Pick<ViewWrapperProps, "item" | "isValid" | "ListItemComponent"> {
    item: IListItem;
    onItemTextChanged: (item: IListItem, newItemText: string) => void;
    removeItem: () => void;
}

interface ItemContainerState {
    isFocus: boolean;
    isHovered: boolean;
    mode: "view" | "edit";
}

export class ItemContainer extends React.Component<ItemContainerProps, ItemContainerState> {
    constructor(props) {
        super(props);
        this.state = {
            // mode = view / edit
            mode: "view",
            isHovered: false,
            isFocus: false,
        };
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onTextChanged = this.onTextChanged.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    onMouseEnter(e) {
        this.setState({
            isHovered: true,
        });
    }

    onMouseLeave(e) {
        this.setState({
            isHovered: false,
        });
    }

    onFocus(e) {
        this.setState({
            isFocus: true,
            mode: "edit",
        });
    }

    onDelete() {
        this.props.removeItem();
    }

    onTextChanged(newItemText) {
        const { item } = this.props;
        this.props.onItemTextChanged(item, newItemText);
        this.setState({
            isFocus: false,
            mode: "view",
        });
    }

    render() {
        const { item, ListItemComponent, isValid } = this.props;
        const showPencil = this.state.isHovered && !this.state.isFocus;
        const isViewMode = this.state.mode === "view";
        return (
            <div
                className="list-item-container"
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
            >
                {isViewMode ? (
                    <ViewWrapper
                        item={item}
                        isValid={isValid}
                        showPencil={showPencil}
                        ListItemComponent={ListItemComponent}
                        onFocus={this.onFocus}
                        onDelete={this.onDelete}
                    />
                ) : (
                    <EditWrapper
                        item={item}
                        ListItemComponent={ListItemComponent}
                        onTextChanged={this.onTextChanged}
                    />
                )}
            </div>
        );
    }
}

type TListItemComponent = React.ComponentType<{
    item: IListItem;
    isEditable: boolean;
}>;

interface ViewWrapperProps {
    isValid?: boolean;
    item: IListItem;
    ListItemComponent: TListItemComponent;
    onDelete?: React.MouseEventHandler<HTMLSpanElement>;
    onFocus?: React.MouseEventHandler<HTMLDivElement>;
    showPencil?: boolean;
}

const ViewWrapper = ({ item, showPencil, ListItemComponent, onFocus, onDelete, isValid }: ViewWrapperProps) => {
    return (
        <div
            style={{ display: "flex" }}
            onClick={onFocus}
            className={isValid ? "valid-item" : "invalid-item"}
        >
            <ListItemTextLine>
                <ListItemComponent
                    item={item}
                    isEditable={false}
                />
                {showPencil ? <i className="sw-icon-edit customCategoriesWizard-editor-edit-domain-icon" /> : null}
            </ListItemTextLine>
            <span
                className="delete-item"
                onMouseUp={onDelete}
            >
                <SWReactIcons
                    iconName="clear"
                    size="sm"
                    className="customCategoriesWizard-editor-remove-domain"
                />
            </span>
        </div>
    );
};

interface EditWrapperProps {
    item: IListItem;
    ListItemComponent: TListItemComponent;
    onTextChanged: (newText: string) => void;
}

class EditWrapper extends React.Component<EditWrapperProps> {
    private wrapperRef = React.createRef<HTMLSpanElement>();

    constructor(props) {
        super(props);
        this.onBlur = this.onBlur.bind(this);
        this.onInput = this.onInput.bind(this);
    }

    render() {
        const { item, ListItemComponent } = this.props;
        return (
            <span
                ref={this.wrapperRef}
                className="list-item-edit"
                onBlur={this.onBlur}
                onKeyPress={this.onInput}
            >
                <ListItemComponent
                    item={item}
                    isEditable={true}
                />
            </span>
        );
    }

    initInput() {
        const contentEditable = this.wrapperRef.current?.querySelector<HTMLSpanElement>("[contentEditable]");
        if (contentEditable) {
            this.autoFocus(contentEditable);
        }
    }

    submit() {
        const contentEditable = this.wrapperRef.current?.querySelector<HTMLSpanElement>("[contentEditable]");
        if (contentEditable) {
            const newText = _.trim(contentEditable.innerText);
            this.props.onTextChanged(newText);
        }
    }

    onInput(e) {
        if (e.key === "Enter") {
            this.submit();
        }
    }

    componentDidMount() {
        this.initInput();
    }

    componentDidUpdate() {
        this.initInput();
    }

    onBlur() {
        this.submit();
    }

    autoFocus(element: HTMLElement) {
        element.focus();
        this.setEndOfContenteditable(element);
    }

    setEndOfContenteditable(contentEditableElement: HTMLElement) {
        const selection = window.getSelection();
        const range = document.createRange();

        range.selectNodeContents(contentEditableElement);
        range.collapse(false);

        selection?.removeAllRanges();
        selection?.addRange(range);
    }
}
